import { PhoneAuthStepPanel } from '@/components/auth/PhoneAuthStepPanel';
import type { PhoneAuthStep } from '@/types/phone-auth-flow';
import type { RequestCodeMethod } from '@/types/dto/phone-auth.dto';

interface BookingAuthStepProps {
  authStep: PhoneAuthStep;
  isRequestingCode: boolean;
  isValidatingCode: boolean;
  nameDescription?: string;
  nameTitle?: string;
  onAuthStepChange: (step: PhoneAuthStep) => void;
  onPhoneNumberChange: (value: string) => void;
  onRequestCode: (method: RequestCodeMethod) => void;
  onUserNameChange: (value: string) => void;
  onValidateCode: () => void;
  onVerificationCodeChange: (value: string) => void;
  phoneNumber: string;
  phoneRequestMethod: RequestCodeMethod | null;
  userName: string;
  verificationCode: string;
}

const BookingAuthStep = ({
  nameDescription = 'Seu nome para o agendamento',
  nameTitle,
  ...props
}: BookingAuthStepProps) => <PhoneAuthStepPanel {...props} nameDescription={nameDescription} nameTitle={nameTitle} />;

export default BookingAuthStep;
